module.exports = __webpack_public_path__ + "static/img/perseption.646b7de.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/perseption.jpeg
// module id = wXHd
// module chunks = 7